import * as React from 'react';
export const FloatingAreaContext = React.createContext(null);
/** FloatingArea 컨텍스트를 읽는다. Provider 밖이면 예외를 던진다. */
export function useFloatingAreaContext() {
    const context = React.useContext(FloatingAreaContext);
    if (!context) {
        throw new Error('FloatingArea는 FloatingAreaProvider 내부에서 사용해야 합니다.');
    }
    return context;
}
//# sourceMappingURL=context.js.map